import { launchState, bizgainOnboardingRoutes } from 'Features/bizgainOnboarding/constants';
import { store } from 'Store/store';
import { mediaPlanStatus } from 'Features/dashboard/constants';

export const getRouteFromLaunchState = (campaignLaunchState, params) => {
  let routeName;
  switch (campaignLaunchState) {
    case launchState.OBJECTIVE: routeName = bizgainOnboardingRoutes.SubsequentSelectObjective.name; break;
    case launchState.PROMOTESERVICES: routeName = bizgainOnboardingRoutes.SubsequentPromoteServices.name;break;
    case launchState.OFFER: routeName = bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name;break;
    case launchState.CREATIVES: routeName = bizgainOnboardingRoutes.SubsequentImageCreatives.name; break;
    case launchState.CREATIVESPREVIEW: routeName = bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.name; break;
    case launchState.CREATIVESEDIT: routeName = bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name; break;
    case launchState.FACEBOOKADPREVIEW: routeName = bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name;break;
    case launchState.FACEBOOKADEDIT: routeName = bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name;break;
    case launchState.GOOGLEADPREVIEW: routeName = bizgainOnboardingRoutes.SubsequentGoogleAds.name; break;
    case launchState.GOOGLEADEDIT: routeName = bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name; break;
    case launchState.CREATIVEANIMATION: routeName = bizgainOnboardingRoutes.SubsequentCreativeAnimation.name;break;
    case launchState.AGEGENDERTARGETING: routeName = bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name; break;
    case launchState.LOCATIONTARGETING: routeName = bizgainOnboardingRoutes.SubsequentLocationTargeting.name; break;
    case launchState.LINKACCOUNTS: routeName = bizgainOnboardingRoutes.LinkAccounts.name; break;
    case launchState.ADACCOUNTSETUPANIMATION: routeName = bizgainOnboardingRoutes.AdAccountSetupAnimation.name;break;
    case launchState.CHANNELSELECTION: routeName = bizgainOnboardingRoutes.ChannelSelection.name;break;
    case launchState.FACEBOOKINTERESTS: routeName = bizgainOnboardingRoutes.FacebookInterests.name;break;
    case launchState.GOOGLEKEYWORDS: routeName = bizgainOnboardingRoutes.GoogleKeywords.name;break;
    case launchState.BUDGET: routeName = bizgainOnboardingRoutes.SubsequentBudget.name;break;
    case launchState.LAUNCHANIMATION: routeName = bizgainOnboardingRoutes.LaunchAnimation.name; break;
    // redirection for shorten flow
    case launchState.TARGETINGV2: routeName = bizgainOnboardingRoutes.TargetingV2.name; break;
    case launchState.BusinessDetailsV2: routeName = bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.name; break;
    case launchState.BusinessDetailsSetupAnimationV2: routeName = bizgainOnboardingRoutes.SubsequentBusinessDetailsSetupAnimationV2.name; break;
    case launchState.CreativeDetailsV2: routeName = bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name; break;
  }
  if (!routeName) {
    return;
  }
  return { name: routeName, params: { ...params } };
}

export const goToCurrentLaunchState = (router, campaignLaunchState, params) => {
  let route = getRouteFromLaunchState(campaignLaunchState, params);
  router.push(route);
}

export const getLaunchStateFromCurrentRoute = (route) => {
  let currentLaunchState;
  switch (route) {
    case bizgainOnboardingRoutes.SubsequentSelectObjective.name: currentLaunchState = launchState.OBJECTIVE; break;
    case bizgainOnboardingRoutes.SubsequentPromoteServices.name: currentLaunchState = launchState.PROMOTESERVICES;break;
    case bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name: currentLaunchState = launchState.OFFER;break;
    case bizgainOnboardingRoutes.SubsequentImageCreatives.name: currentLaunchState = launchState.CREATIVES; break;
    case bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.name: currentLaunchState = launchState.CREATIVESPREVIEW; break;
    case bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name: currentLaunchState = launchState.CREATIVESEDIT; break;
    case bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name: currentLaunchState = launchState.FACEBOOKADPREVIEW;break;
    case bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name: currentLaunchState = launchState.FACEBOOKADEDIT;break;
    case bizgainOnboardingRoutes.SubsequentCreativeAnimation.name: currentLaunchState = launchState.CREATIVEANIMATION; break;
    case bizgainOnboardingRoutes.SubsequentGoogleAds.name: currentLaunchState = launchState.GOOGLEADPREVIEW; break;
    case bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name: currentLaunchState = launchState.GOOGLEADEDIT; break;
    case bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name: currentLaunchState =  launchState.AGEGENDERTARGETING; break;
    case bizgainOnboardingRoutes.SubsequentLocationTargeting.name: currentLaunchState = launchState.LOCATIONTARGETING; break;
    case bizgainOnboardingRoutes.LinkAccounts.name: currentLaunchState = launchState.LINKACCOUNTS; break;
    case bizgainOnboardingRoutes.AdAccountSetupAnimation.name: currentLaunchState = launchState.ADACCOUNTSETUPANIMATION; break;
    case bizgainOnboardingRoutes.SubsequentBudget.name: currentLaunchState = launchState.BUDGET;break;
    case bizgainOnboardingRoutes.ChannelSelection.name: currentLaunchState = launchState.CHANNELSELECTION;break;
    case bizgainOnboardingRoutes.FacebookInterests.name: currentLaunchState = launchState.FACEBOOKINTERESTS;break;
    case bizgainOnboardingRoutes.GoogleKeywords.name: currentLaunchState = launchState.GOOGLEKEYWORDS;break;
    case bizgainOnboardingRoutes.LaunchAnimation.name: currentLaunchState = launchState.LAUNCHANIMATION; break;
    // for shorten flow
    case bizgainOnboardingRoutes.TargetingV2.name: currentLaunchState = launchState.TARGETINGV2; break;
    case bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.name: currentLaunchState = launchState.BusinessDetailsV2; break;
    case bizgainOnboardingRoutes.SubsequentBusinessDetailsSetupAnimationV2.name: currentLaunchState = launchState.BusinessDetailsSetupAnimationV2; break;
    case bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name: currentLaunchState = launchState.CreativeDetailsV2; break;
  }
  return currentLaunchState;
}

export const hasActiveMediaPlans = (upcomingCampaigns) => {
  return upcomingCampaigns && upcomingCampaigns.length > 0 && upcomingCampaigns.map(upcomingCampaign=>upcomingCampaign.status).some(status=>status == mediaPlanStatus.active);
}

export const setHasOneDraftCampaign = (draftBizgainCampaigns, upcomingBizgainCampaigns) => {
  if ((draftBizgainCampaigns && draftBizgainCampaigns.length == 1) && !hasActiveMediaPlans(upcomingBizgainCampaigns)) {
    store.dispatch('setHasOneDraftCampaign', true);
  } else {
    store.dispatch('setHasOneDraftCampaign', false);
  }
}

